<template>
  <div id="order-balance" class="order-panel">
    <div class="order-panel-margin" v-if="!User.is_palmyou">
      <div class="panel-title">余额信息</div>
      <div class="panel-body">
        <div class="pay-ways">
          <div class="pay-way inline-table" @click="payWay={money: true}" :class="{active: payWay.money}">
            <div class="left table-cell">
              <img src="../../assets/imgs/money.png">
            </div>
            <div class="middle table-cell">
              可用余额
              <div class="info"><span>￥</span>{{peer.balance_amount/100}}</div>
            </div>
          </div>

          <!-- <div class="pay-ps" v-if="peer.balance_amount < orderDiff.diff_fee">
            余额不足，请先充值
            <router-link :to="{ name:'account', query: { fromParam: formatParam({ oid: order.user_order_id }), from: 'orderDiffPay' }}" class="el-button common-button el-button--primary">立即充值</router-link>
          </div> -->
        </div>
      </div>
    </div>

    <div class="panel-body pay-action clearfix">
      <div class="pay-wrap fr">
        <div class="total-pay">
          <span>{{orderDiff.item}}</span>
          <label>￥<i>{{ orderDiff.diff_fee / 100 }}</i></label>
        </div>

        <el-button type="primary"
          class="common-button"
          @click="pay">
          立即支付</el-button>
      </div>
    </div>

    <!--支付对话框-->
    <el-dialog title="补缴费用" v-model="payDialog" custom-class="pay-dialog" :show-close="false">
      <span>补缴费用将使用余额支付, 是否确认支付?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialog = false">取 消</el-button>
        <el-button type="primary" @click="doPay">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 余额不足 -->
    <insufficient-balance-modal
      v-model="rechargeDialog"
      :order-id="order.user_order_id"
      :from="'orderDiffPay'"
      :chargePrice="orderDiff.diff_fee - peer.balance_amount"
      :fromParam="{ oid: order.user_order_id }"
    ></insufficient-balance-modal>
  </div>
</template>

<script>
import User from '@/libs/user';
import utils from '../../libs/utils';
import Http from '../../libs/http';
import insufficientBalanceModal from '../../pages/ordering/modals/insufficient-balance-modal';

export default {
  props: {
    order: Object,
    peer: Object,
    orderDiff: Object,
  },
  components: {
    insufficientBalanceModal,
  },
  data() {
    return {
      payWay: { money: true },
      payDialog: false,
      rechargeDialog: false,
      User,
    };
  },
  methods: {
    // 支付
    pay() {
      // 如果是金棕榈订单，则直接跳转到支付页面
      if (User.is_palmyou) {
        this.$router.replace({
          name: 'payConfirm',
          params: {
            oid: this.order.user_order_id,
          },
          query: {
            typeid: 4,
            payPrice: this.orderDiff.diff_fee / 100,
          },
        });
        return;
      }

      if (this.peer.balance_amount >= this.orderDiff.diff_fee) {
        this.payDialog = true;
      } else {
        this.rechargeDialog = true;
      }
    },

    formatParam: utils.formatParam,

    // 真正支付
    doPay() {
      Http.post('/price_diff_pay', {
        id: this.orderDiff.id,
      }, {
        noToast: true,
      }).then(() => {
        utils.msg.success('支付成功');
        this.$router.replace({ name: 'orderDetail', params: { oid: this.order.user_order_id } });
      }, (res) => {
        this.paying = false;

        if (!res || !res.msg) {
          return utils.msg.error('网络连接发生错误，请稍后重试');
        }

        if (res.msg.indexOf('无需') > -1) {
          utils.msg.error(res.msg);
          return this.$router.replace({ name: 'orderDetail', params: { oid: this.order.user_order_id } });
        }

        utils.msg.error(res.msg);
      }).finally(() => {
        this.payDialog = false;
      });
    },
  },
};
</script>

<style lang="less">
#order-balance {
.el-dialog {
  width: 570px;
}
}
</style>


<style lang="less" scoped>
@import  '../../assets/less/variable';

#order-balance {
  &.order-panel {
    background-color: white;
  }
  .order-panel-margin {
    margin-top: 16px;
  }

  &.order-info-panel {
    .panel-body {
      display: flex;
    }

    .order-col {
      flex: 1;
    }
  }

  .panel-title {
    font-size: 18px;
    color: #333;
    height: 50px;
    line-height: 50px;
    padding: 0 30px 0 20px;
    text-align: left;
    font-weight: 500;
  }

  .panel-body {
    padding: 10px 30px 30px 40px;
  }

  .pay-ways{
    font-size:0;
    padding-top:10px;
  }

  .pay-way{
    height:70px;
    border:1px solid @border;
    border-radius:5px;
    cursor:pointer;
    vertical-align: middle;

    &.active{
      border-color:@main;
    }

    &+.pay-way{
      margin-left:40px;
    }

    &>div{
      vertical-align:middle;
    }

    .left{
      width:64px;
      text-align:center;
    }

    .middle{
      font-size:14px;
      color:#333;
      min-width:100px;
      overflow:hidden;
      padding-right: 10px;

      .info{
        margin-top:4px;
        color:@orange;
        font-size:20px;

        span{
          font-size:14px;
        }
      }
    }

    .right{
      width:29px;

      .el-checkbox{
        pointer-events:none;
      }

      .el-checkbox__inner{
        border-radius:50%;
      }
    }
  }

  .pay-ps{
    display:inline-block;
    vertical-align:middle;
    font-size:15px;
    color: @red;
    margin-left:30px;
    padding-left:32px;
    position:relative;

    &::before{
      content:"";
      border-left:1px solid @border;
      height:20px;
      position:absolute;
      left:0;
      top:7px;
    }

    .el-button{
      margin-left:12px;
    }
  }

  .pay-action{
    border-top: 14px solid #f7f8fa;
    padding: 20px 30px 20px 0;
  }

  .pay-wrap{
    text-align:right;

    .total-pay{
      font-size:16px;
      color:#fc7906;
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span{
        color:#777;
      }

      label{
        display:inline-block;
      }

      i{
        font-size:24px;
        font-style:normal;
      }
    }

    .el-button{
      margin-top:20px;
      width:220px;
      height:40px;
      line-height:38px;
      font-size:16px;
      background-color:#4c97f7;

      &:active{
        background-color:darken(#4c97f7,7%);
      }

      &:disabled{
        background-color:#EFF2F7;
        color: #5e9be1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-balance.vue